import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
// import ConnectChannelImg from "src/assets/images/tour-guide/dashboard-guide.png";
import ConnectChannelImg from "src/assets/images/tour-guide/social-site-connections.png";

interface ConnectionModalProps {
  open: boolean;
  onClose: () => void;
}

const ConnectionModal: React.FC<ConnectionModalProps> = ({ open, onClose }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up("sm")); // md & up for horizontal layout

  const handleConnect = () => {
    navigate("/settings/facebook"); // Navigate to Channels section
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 3,
        },
      }}
    >
      <DialogContent>
        <Stack
          direction={isSmUp ? "row" : "column"}
          spacing={4}
          alignItems="center"
          justifyContent="center"
        >
          {/* Image */}
          <Box flexShrink={0}>
            <img
              src={ConnectChannelImg}
              alt="Connect a Channel"
              style={{
                width: isSmUp ? 200 : 120,
                height: isSmUp ? 200 : 120,
                objectFit: "contain",
              }}
            />
          </Box>

          {/* Content */}
          <Stack
            spacing={2}
            flex={1}
            textAlign={isSmUp ? "left" : "center"}
            alignItems={isSmUp ? "flex-start" : "center"}
          >
            {/* Title */}
            <Typography variant="h5" fontWeight={600}>
              Connect a Channel
            </Typography>

            {/* Subtitle */}
            {/* <Typography variant="body1" color="text.primary">
              You have successfully completed the dashboard tour!
            </Typography> */}

            {/* Paragraph */}
            <Typography variant="body2" color="text.secondary">
              To start receiving messages and comments, please add and connect
              at least one page or number from the CRM Settings → Channels
              section. This can be a Facebook page, Instagram account, or
              WhatsApp number.
            </Typography>

            {/* Buttons */}
            <Stack
              direction={isSmUp ? "row" : "column"}
              spacing={2}
              mt={1}
              width="100%"
            >
              <Button
                variant="contained"
                size="large"
                onClick={handleConnect}
                sx={{
                  borderRadius: 3,
                  textTransform: "none",
                  fontWeight: 600,
                  flex: 1,
                }}
              >
                Connect Now
              </Button>

              <Button
                variant="text"
                onClick={onClose}
                sx={{
                  textTransform: "none",
                  color: "text.secondary",
                  flex: 1,
                }}
              >
                Dismiss
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ConnectionModal;
